<template>
  <NavigationBar @toggleBar="toggleBar" />
  <div class="main-content" :class="{ 'main-content-small': small, 'navbar-hidden': !isNavBarVisible }">
    <router-view :class="{ 'router': isNavBarVisible }" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import NavigationBar from '@/components/layout/NavigationBar.vue';
import { useNavigationStore } from '@/store/NavigationStore';
import { useUserStore } from '@/store/UserStore';
import Cookies from 'js-cookie'

const navigationStore = useNavigationStore();
const userStore = useUserStore();

const small = ref(false);

const toggleBar = () => {
  small.value = !small.value
}

const isNavBarVisible = computed(() => {
  return navigationStore.isNavBarVisible
})

onMounted(async () => {
  if (Cookies.get('access_token')) {
      await userStore.fetchMyUserInfo()
  }
})
</script>

<style></style>
